import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  Tabs,
  Tab,
  Box,
  ButtonBase,
  CardHeader,
  CardContent,
  Avatar,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import styled, { css } from 'styled-components';
import isMobile from 'is-mobile';
import { getNewNotifications } from '~/store/modules/newNotifications/actions';
import { ToastCtx } from '~/providers/ToastProvider';
import messages from '../../helpers/api/messages';
import usersApi from '../../helpers/api/users';
import { maps } from '~/helpers/api';
import { Icon, Spinner } from '../../elements';
import { Modal } from '../../components';
import GoogleMaps from '~/components/GoogleMaps';
import { Header } from '../../compositions';
import IconVrRefeicao from '../../assets/vrpat/xs-logo-refeicao.svg';
import IconVr from '../../assets/vrpat/xs-logo-vr.svg';
import IconVrAlimentacao from '../../assets/vrpat/xs-logo-aliment.svg';
import { InternalContainer, Wrapper } from '../common';
import CarrinhoSVG from './carrinho.svg';
import GarfoSVG from './garfo.svg';
import MensagemSVG from './mensagem.svg';
import isIOS from '~/helpers/isIOS';
import { VRPAT } from '~/config/constants';

const Body = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding-bottom: 34px;
  color: ${({ theme }) => theme.colors.gray400};

  padding-top: 20px;
  margin-top: -188px;
  min-height: ${({ minHeight }) => minHeight}px;

  @media (max-width: ${({ theme }) => theme.devices.tablet}) {
    padding-top: 20px;
    margin-top: -92px;
  }
`;

const HeaderWrapper = styled(Wrapper)`
  height: 215px;
  @media (max-width: ${({ theme }) => theme.devices.tablet}) {
    height: 125px;
    margin-top: 20px;
  }
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: ${({ theme }) => theme.colors.white};
`;

const Card = styled(ButtonBase)`
  display: flex;
  flex-direction: column;
  align-items: stretch !important;
  text-align: left;
  transition: 0.5s box-shadow;
  width: 100%;
  max-height: ${({ hasLink }) => (hasLink ? 'unset' : '205px')};
  opacity: ${({ read }) => (read ? 0.5 : 1)};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  border-radius: 10px !important;
  margin-bottom: 16px !important;
  position: relative;
  padding-right: 40px !important;
  color: ${({ theme }) => theme.colors.gray500};

  .MuiCardHeader-root {
    .MuiCardHeader-action {
      top: 50%;
      right: 14px;
      transform: translateY(-50%);
      position: absolute;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: ${({ theme }) => theme.colors.primary};
    }
    .MuiCardHeader-content {
      display: flex;
      flex-direction: column;
      .MuiCardHeader-title {
        order: 2;
        font-weight: bold;
        font-size: 1.1rem;
        ${({ hasLink }) =>
          !hasLink &&
          css`
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
          `};
      }
      .MuiCardHeader-subheader {
        order: 1;
        font-size: 0.8rem;
      }
    }
  }
  .MuiAvatar-root {
    width: 60px;
    height: 60px;
  }
  .MuiCardContent-root {
    line-height: 1.2rem;
    padding-top: 0 !important;
    padding-bottom: 0;
    margin-bottom: 16px;
    ${({ hasLink }) =>
      !hasLink &&
      css`
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      `};
  }
`;

const Loading = styled.div`
  display: flex;
  justify-content: center;
`;

const Panel = styled(Box)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

const ModalContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 32px;
`;

const ModalTitle = styled.h2`
  border-left: 20px solid ${({ theme }) => theme.colors.secondary};
  padding: 12px 0 12px 12px;
  font-size: 1.7rem;
  margin-left: -32px;
  color: ${({ theme }) => theme.colors.gray500} !important;
`;
const ModalP = styled.p`
  margin: 16px 0;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.gray500} !important;
`;
const ModalAddress = styled(Grid).attrs({
  spacing: 2,
  container: true,
})`
  &.MuiGrid-container {
    flex-wrap: nowrap;
    align-items: center;
    padding: 32px 0;
    color: ${({ theme }) => theme.colors.primary};
    i {
      font-size: 40px;
    }
  }
`;
const ModalAddressTitle = styled.h3`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.gray500} !important;
`;
const ModalAddressSubtitle = styled.h4`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.gray400} !important;
`;

const TabsCustom = styled(Tabs)`
  .MuiTab-root {
    color: ${({ theme }) => theme.colors.gray500};
    text-transform: none;
    font-weight: bold;
    opacity: 0.5;
    min-width: inherit !important;
    padding-left: 24px;
    padding-right: 24px;
    img {
      display: block;
    }
    &.MuiTab-textColorInherit.Mui-selected {
      color: ${({ theme }) => theme.colors.primary};
      opacity: 1;
    }
  }
  .PrivateTabIndicator-root-1 {
    height: 3px;
  }
`;

const LinkAddress = styled.a`
  text-decoration: underline;
  cursor: pointer;
`;

const Paragraph = styled(Typography).attrs({ variant: 'subtitle1' })`
  margin: 24px 0 !important;
`;

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Panel p={3}>{children}</Panel>}
    </div>
  );
}

const iconCard = [MensagemSVG, GarfoSVG, CarrinhoSVG];

const Notifications = () => {
  const [documentHeight, setDocumentHeight] = useState(window.innerHeight);
  const [body, setBody] = useState();
  const [bodyPositionY, setBodyPositionY] = useState();
  const [all, setAll] = useState();
  const [refeicao, setRefeicao] = useState();
  const [alimentacao, setAlimentacao] = useState();
  const [allLoading, setAllLoading] = useState(false);
  const [refeicaoLoading, setRefeicaoLoading] = useState(false);
  const [alimentacaoLoading, setAlimentacaoLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [modalData, setModalData] = useState();
  const [googleMapsApiKey, setGoogleMapsApiKey] = useState('');
  const toast = useContext(ToastCtx);
  const user = useSelector(state => state.user);
  const issuer = useSelector(state => state?.issuer);
  const dispatch = useDispatch();
  const isVR = issuer?.name === VRPAT;

  useEffect(() => {
    maps
      .googleMapsKey()
      .then(response => setGoogleMapsApiKey(response?.keyGoogleMaps));
  }, []);

  const handleClick = useCallback(
    async notification => {
      if (notification.link) {
        window.open(notification.link);
      } else {
        try {
          setLoadingModal(true);
          setOpenModal(true);
          if (notification.produto) {
            const data = await usersApi.getNotificationData(notification.id);

            setModalData(data);
          } else {
            setModalData(notification);
          }
        } catch (e) {
          toast.dispatch(messages(e));
          setOpenModal(false);
        } finally {
          setLoadingModal(false);
        }
      }
    },
    [toast, user.email],
  );

  const renderCard = useCallback(
    (notification, i) => (
      <Card
        aria-label="Notificação"
        onClick={() => handleClick(notification)}
        key={i}
        read={notification.lida && tabValue > 0}
        hasLink={notification.link}
      >
        <CardHeader
          avatar={
            <Avatar style={{ padding: 16 }}>
              <img src={iconCard[tabValue]} height="100%" alt="" />
            </Avatar>
          }
          action={<Icon icon={['fas', 'chevron-right']} />}
          title={notification.titulo}
          subheader={notification.data}
        />
        <CardContent>
          {notification.mensagem || notification.subtitulo}
          {notification.validade && (
            <p style={{ marginTop: 16, fontSize: '0.7rem' }}>
              <b>Val. {notification.validade}</b>
            </p>
          )}
        </CardContent>
      </Card>
    ),
    [handleClick, tabValue],
  );

  const getNotifications = useCallback(
    (tab = 0) => {
      const func = [
        async () => {
          setAllLoading(true);
          try {
            const data = await usersApi.getNotifications();
            setAll(data);
          } catch (e) {
            toast.dispatch(messages(e));
          }
          setAllLoading(false);
        },
        async () => {
          setRefeicaoLoading(true);
          try {
            const data = await usersApi.getPromotions(31);
            setRefeicao(data);
          } catch (e) {
            toast.dispatch(messages(e));
          }
          setRefeicaoLoading(false);
        },
        async () => {
          setAlimentacaoLoading(true);
          try {
            const data = await usersApi.getPromotions(27);
            setAlimentacao(data);
          } catch (e) {
            toast.dispatch(messages(e));
          }
          setAlimentacaoLoading(false);
        },
      ];

      func[tab]();
    },
    [toast, user.email],
  );

  const handleClose = useCallback(() => {
    dispatch(getNewNotifications());
    getNotifications(tabValue);
    setOpenModal(false);
  }, [tabValue, getNotifications, dispatch, user.email]);

  const handleChange = useCallback(
    (_e, newValue) => {
      setTabValue(newValue);
      getNotifications(newValue);
    },
    [getNotifications],
  );

  useEffect(() => {
    window.addEventListener('resize', () => {
      setDocumentHeight(window.innerHeight);
    });
  }, []);

  useEffect(getNotifications, []);

  useEffect(() => {
    setTimeout(() => {
      setDocumentHeight(window.innerHeight);
      setBodyPositionY(body?.getBoundingClientRect().top);
    });
  }, [body]);

  function setMobileMapsUrl(data) {
    if (isMobile()) {
      // Execute only in mobile screens
      const latDestination = data.estabelecimento.lat;
      const lngDestination = data.estabelecimento.lon;

      return `${
        // Checking if it's iOS in order to use the native maps from Apple, if possible.
        isIOS() ? 'maps' : 'https'
      }://maps.google.com/maps?daddr=${latDestination},${lngDestination}`;
    }

    return null;
  }

  function handleDesktopMapsUrl(data) {
    const latDestination = data.estabelecimento.lat;
    const lngDestination = data.estabelecimento.lon;

    function originAndDestiny(position) {
      return `https://maps.google.com/maps?saddr=${position.coords.latitude},${position.coords.longitude}&daddr=${latDestination},${lngDestination}`;
    }

    function onlyDestiny() {
      return `https://maps.google.com/maps?daddr=${latDestination},${lngDestination}`;
    }

    if (!isMobile()) {
      // Execute only in desktop screens
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            window.open(originAndDestiny(position));
          },
          () => {
            window.open(onlyDestiny());
          },
        );
      }
    }
  }

  return (
    <>
      <InternalContainer>
        <Header />
        <HeaderWrapper>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <IconButton
                style={{ width: 30, height: 30, fontSize: 16, color: 'white' }}
                component={Link}
                to="/home"
              >
                <Icon icon={['far', 'chevron-left']} />
              </IconButton>
            </Grid>
            <Grid item>
              <Title>Notificações</Title>
            </Grid>
          </Grid>
        </HeaderWrapper>
      </InternalContainer>
      <Body minHeight={documentHeight - bodyPositionY} ref={el => setBody(el)}>
        <InternalContainer>
          <Wrapper>
            <TabsCustom
              value={tabValue}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                aria-label="Aba mensagens"
                label={
                  <Grid container spacing={2} alignItems="center">
                    {isVR && (
                      <Grid item>
                        <img src={IconVr} alt="" />
                      </Grid>
                    )}
                    <Grid item>Mensagens</Grid>
                  </Grid>
                }
              />
              <Tab
                aria-label="Aba refeição"
                label={
                  <Grid container spacing={2} alignItems="center">
                    {isVR && (
                      <Grid item>
                        <img src={IconVrRefeicao} alt="" />
                      </Grid>
                    )}
                    <Grid item>Refeição</Grid>
                  </Grid>
                }
              />
              <Tab
                aria-label="Aba alimentação"
                label={
                  <Grid container spacing={2} alignItems="center">
                    {isVR && (
                      <Grid item>
                        <img src={IconVrAlimentacao} alt="" />
                      </Grid>
                    )}
                    <Grid item>Alimentação</Grid>
                  </Grid>
                }
              />
            </TabsCustom>
            <TabPanel value={tabValue} index={0}>
              {allLoading && (
                <Loading>
                  <Spinner />
                </Loading>
              )}
              {!allLoading && all && all.map(renderCard)}
              {!allLoading &&
                (!all || (all && all.length === 0)) &&
                'Não há notificações'}
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
              {refeicaoLoading && (
                <Loading>
                  <Spinner />
                </Loading>
              )}
              {!refeicaoLoading && refeicao && refeicao.map(renderCard)}
              {!refeicaoLoading &&
                (!refeicao || (refeicao && refeicao.length === 0)) &&
                'Não há notificações'}
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              {alimentacaoLoading && (
                <Loading>
                  <Spinner />
                </Loading>
              )}
              {!alimentacaoLoading &&
                alimentacao &&
                alimentacao.map(renderCard)}
              {!alimentacaoLoading &&
                (!alimentacao || (alimentacao && alimentacao.length === 0)) &&
                'Não há notificações'}
            </TabPanel>
          </Wrapper>
        </InternalContainer>
      </Body>
      <Modal
        open={openModal}
        handleClose={handleClose}
        aria-label="Detalhes da notificação"
      >
        <ModalContainer>
          {loadingModal && (
            <Loading>
              <Spinner />
            </Loading>
          )}
          {!loadingModal && modalData && (
            <>
              <ModalTitle>{modalData.titulo}</ModalTitle>
              {modalData.subtitulo && <ModalP>{modalData.subtitulo}</ModalP>}
              {googleMapsApiKey && modalData.estabelecimento && (
                <GoogleMaps
                  center={{
                    lat: modalData.estabelecimento.lat,
                    lng: modalData.estabelecimento.lon,
                  }}
                  marker={{
                    lat: modalData.estabelecimento.lat,
                    lng: modalData.estabelecimento.lon,
                  }}
                  googleMapsApiKey={googleMapsApiKey}
                />
              )}
              {modalData.estabelecimento && (
                <ModalAddress>
                  <Grid item>
                    <Icon icon={['fas', 'map-marker-alt']} />
                  </Grid>
                  <Grid item>
                    <ModalAddressTitle>
                      {modalData.estabelecimento.nomeFantasia}
                    </ModalAddressTitle>
                    {/* eslint-disable-next-line */}
                    <LinkAddress
                      aria-label="Link para o Mapa"
                      href={setMobileMapsUrl(modalData)} // href and onClick because the app suggestions only work with links in mobiles
                      onClick={() => handleDesktopMapsUrl(modalData)}
                      target={isMobile() ? '_self' : '_blank'}
                      rel="noopener noreferrer"
                    >
                      <ModalAddressSubtitle>
                        {modalData.estabelecimento.tipoLogradouro}{' '}
                        {modalData.estabelecimento.rua}
                        {', '}
                        {modalData.estabelecimento.numero}
                        {modalData.estabelecimento.complemento &&
                          modalData.estabelecimento.complemento !== ' ' &&
                          ` - ${modalData.estabelecimento.complemento}`}
                        {' - '}
                        {modalData.estabelecimento.cep}
                        {modalData.estabelecimento.bairro &&
                          modalData.estabelecimento.bairro !== ' ' &&
                          ` - ${modalData.estabelecimento.bairro}`}
                        {' - '}
                        {modalData.estabelecimento.cidade}/
                        {modalData.estabelecimento.estado}
                      </ModalAddressSubtitle>
                    </LinkAddress>
                  </Grid>
                </ModalAddress>
              )}
              {modalData.mensagem && (
                <Paragraph>{modalData.mensagem}</Paragraph>
              )}
            </>
          )}
        </ModalContainer>
      </Modal>
    </>
  );
};

export default Notifications;
